// extracted by mini-css-extract-plugin
export default {"wrapper":"homepage_wrapper__wCb+0"};